import { all } from 'redux-saga/effects';
import { authSagas } from './auth.saga';
import { shiftsSagas } from './shifts.saga';
import { talentSagas } from './talent.saga';
import { talentSearchSagas } from './talentSearch.saga';
import { companiesSagas } from './company.saga';
import { approvedCompaniesSagas } from './approvedCompanies.saga';
import { otherCompaniesSagas } from './otherCompanies.saga';
import { skillsSagas } from './skills.saga';
import { rejectedUserSagas } from './rejected-user.saga';
import { appSettingsSagas } from './settings.saga';
import { certificatesSagas } from './certificates.saga';
import { invoicesSagas } from './invoices.saga';
import { notificationsSagas } from './notifications.saga';
import { mapSagas } from './map.saga';
import { contractorMapSagas } from './contractorMap.saga';
import { emailMarketingSagas } from './emailMarketing.saga';
import { reportsSagas } from './reports.saga';
import { clientInvoiceReportsSagas } from './clientInvoiceReports.saga';
import { filledUnfilledReportsSagas } from './filledUnfilledReports.saga';
import { userSignupsReportsSagas } from './userSignupsReports.saga';
import { shiftApplicationsReportsSagas } from './shiftApplicationsReports.saga';
import { weeklyInvoiceVerificationSagas } from './weeklyInvoiceVerification.saga';
import { weeklyUnitNumbersSagas } from './weeklyUnitNumbers.saga';
import { commandCentreSagas } from './commandCentreSagas';
import { instantPayReportSagas } from './instantPayReport.saga';
import { paidContractorInvoiceReportSagas } from './paidContractorInvoiceReport.saga';
import { contractorWithdrawalsReportSagas } from './contractorWithdrawalsReport.saga';
import { walletBalanceAgingReportSagas } from './walletBalanceAgingReport.saga';
import { calendarShiftsSagas } from './calendarShifts.saga';
import { manualTimeRequestSagas } from './manualTimeRequest.saga';
import { disputesSagas } from './disputes.saga';
import { timeTrackerSagas } from './timeTracker.saga';
import { platformSettingsSagas } from './platformSettings.saga';

export default function* rootSaga() {
    yield all([
        ...authSagas,
        ...talentSagas,
        ...talentSearchSagas,
        ...shiftsSagas,
        ...companiesSagas,
        ...approvedCompaniesSagas,
        ...otherCompaniesSagas,
        ...appSettingsSagas,
        ...skillsSagas,
        ...rejectedUserSagas,
        ...certificatesSagas,
        ...invoicesSagas,
        ...notificationsSagas,
        ...mapSagas,
        ...contractorMapSagas,
        ...emailMarketingSagas,
        ...reportsSagas,
        ...clientInvoiceReportsSagas,
        ...filledUnfilledReportsSagas,
        ...userSignupsReportsSagas,
        ...shiftApplicationsReportsSagas,
        ...weeklyInvoiceVerificationSagas,
        ...weeklyUnitNumbersSagas,
        ...commandCentreSagas,
        ...instantPayReportSagas,
        ...paidContractorInvoiceReportSagas,
        ...contractorWithdrawalsReportSagas,
        ...walletBalanceAgingReportSagas,
        ...calendarShiftsSagas,
        ...manualTimeRequestSagas,
        ...disputesSagas,
        ...timeTrackerSagas,
        ...platformSettingsSagas,
    ]);
}
